<div class="col-12 row pb-4">
  <div *ngFor="let field of fieldArray | fieldQueryFilter: filters.fieldQuery | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'fieldsPaginate' }; index as i" class="col-sm-4 field-card">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title pb-3">
          <span *ngIf="field.isFavorite" (click)="removeFieldFromFavorites(field, i)" class="text-warning mr-4 pointer-cursor" title="Remove field from Favorites"><i class="fas fa-star"></i></span>
          <span *ngIf="!field.isFavorite" (click)="addFieldToFavorites(field, i)" class="mr-4 pointer-cursor" title="Add field to Favorites"><i class="far fa-star"></i></span>
          <ng-container *ngIf="isBulkEdit; else dataEntry">
            <a class="custom-link" (click)="navigateToBulk(field.fieldID)">{{field.fieldName | titlecase}}</a>
          </ng-container>
          <ng-template #dataEntry>
            <a routerLink="/app/Portal/dataentry/field/{{field.fieldID}}">{{field.fieldName | titlecase}}</a>
          </ng-template>
        </h5>
      </div>
    </div>
  </div>

  <div *ngIf="(fieldArray | fieldQueryFilter: filters.fieldQuery).length == 0" class="text-center ignore-hover">
    <p colspan="9"><em>No fields matching search key words</em></p>
  </div>
</div>

<div class="d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-center p-4">
  <div class="" style="font-size: 0.8em">
    <span class="text-muted">Total: {{(fieldArray | fieldQueryFilter: filters.fieldQuery).length}} </span>
  </div>
  <div class="text-center" style="font-size: 0.9em">
    <pagination-controls (pageChange)="p1 = $event" id="fieldsPaginate"></pagination-controls>
  </div>
  <div class="">
    <div class="input-group input-group-sm" style="font-size: 0.9em">
      <div class="input-group-prepend">
        <label class="input-group-text" style="font-size: 0.9em" for="paginatePerPage">Per Page: </label>
      </div>
      <select class="form-control" [(ngModel)]="paginatePerPage" style="font-size: 0.9em">
        <option value="24">24</option>
        <option value="48">48</option>
        <option value="{{(fieldArray | fieldQueryFilter: filters.fieldQuery).length}}">All</option>
      </select>
    </div>
  </div>
</div>

<!-- List View (i.e. !GalleryDisplay) -->
<!--<div class="row">
  <div class="col-12">
    <div class="rr-elevation-z2 table-responsive">
      <table class="table table-hover rr-table">
        <thead>
          <tr>
            <th class="text-center">Favorites
            <ng-container *ngIf="isAllFields">
              <span class="pl-1 pointer-cursor" title="Sort" *ngIf="fieldArraySort.isFavorite" (click)="sortFieldsBy('isFavorite')">
              <i class="fas fa-sort"></i>
              </span>
              <span *ngIf="!fieldArraySort.isFavorite" class="pl-1 pointer-cursor" title="Sort" (click)="sortFieldsBy('isFavorite')">
              <i class="fas fa-sort" ></i>
              </span>
            </ng-container>
            </th>
            <th class="text-nowrap">Field Name <span class="pl-1 pointer-cursor" title="Sort" *ngIf="fieldArraySort.fieldName"><i class="fas fa-sort-amount-down" (click)="sortFieldsBy('fieldName')"></i></span><span *ngIf="!fieldArraySort.fieldName" class="pl-1 pointer-cursor" title="Sort"><i class="fas fa-sort-amount-up-alt" (click)="sortFieldsBy('fieldName')"></i></span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of fieldArray | fieldQueryFilter: filters.fieldQuery | fieldSortBy: sortColumn : sortDesc | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'fieldsPaginate' }; index as i" class="pointer-cursor">
            <td class="text-center">
              <span *ngIf="field.isFavorite" (click)="removeFieldFromFavorites(field, i)" class="text-warning" title="Remove field from Favorites"><i class="fas fa-star"></i></span>
              <span *ngIf="!field.isFavorite" (click)="addFieldToFavorites(field, i)" title="Add field to Favorites"><i class="far fa-star"></i></span>
            </td>
            <td (click)="goToFieldPage(field.fieldID)"><a routerLink="/app/Portal/field/{{field.fieldID}}">{{field.fieldName}}</a></td>
          </tr>
          <tr *ngIf="(fieldArray | fieldQueryFilter: filters.fieldQuery).length == 0" class="text-center ignore-hover">
            <td colspan="9"><em>No fields matching search key words</em></td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-center p-2">
        <div class="" style="font-size: 0.8em">
          <span class="text-muted">Total: {{(fieldArray | fieldQueryFilter: filters.fieldQuery).length}} </span>
        </div>
        <div class="text-center" style="font-size: 0.9em">
          <pagination-controls (pageChange)="p1 = $event" id="fieldsPaginate"></pagination-controls>
        </div>
        <div class="">
          <div class="input-group input-group-sm" style="font-size: 0.9em">
            <div class="input-group-prepend">
              <label class="input-group-text" style="font-size: 0.9em" for="paginatePerPage">Per Page: </label>
            </div>
            <select class="form-control" [(ngModel)]="paginatePerPage" style="font-size: 0.9em">
              <option value="12">12</option>
              <option value="24">24</option>
              <option value="48">48</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->
